import { useEffect, useState } from "react";
import useThemeStore from "../store/useThemeStore";

/**
 * Resolves the active theme from both the store and document data-theme
 * (marketing pages temporarily force light on <html>).
 */
export function useEffectiveTheme() {
  const storeDark = useThemeStore((state) => state.isDark);

  const readTheme = () =>
    document.documentElement.getAttribute("data-theme") === "dark" ||
    document.body.classList.contains("darkMode");

  const [isDark, setIsDark] = useState(readTheme);

  useEffect(() => {
    setIsDark(readTheme());

    const observer = new MutationObserver(() => {
      setIsDark(readTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme", "class"],
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [storeDark]);

  return isDark;
}
